module.exports = "//static.hsappstatic.net/react-codemirror/static-1.7017/theme/hubspot-canvas-dark.sass"